import { FETCH_ALL_EDUCATIONS } from '../../constants/actionTypes'

export default (vlnEdu = {}, action) => {
    switch (action.type) {
        case FETCH_ALL_EDUCATIONS:
            return action.payload;
        default:
            return vlnEdu;
    }
}